import React from "react";
import { FileDown, Redo2, Undo2 } from "lucide-react";
import { cn } from "../../lib/utils";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";

const ghostBtn =
  "inline-flex h-8 w-8 items-center justify-center rounded-[var(--t-event-pill-radius)] text-[var(--t-meta)] opacity-70 transition-all hover:bg-white/80 hover:text-[var(--t-text)] hover:opacity-100 hover:shadow-sm disabled:cursor-not-allowed disabled:opacity-30";

export function BoardInCanvasControls({
  onUndo,
  onRedo,
  canUndo,
  canRedo,
  onDownloadBoard,
  onAddBoardToNote,
  isAdmin,
}) {
  return (
    <>
      <div
        className="pointer-events-none absolute left-2 top-2 z-20 flex items-center gap-0.5"
        data-testid="board-canvas-controls-left"
      >
        <button
          type="button"
          onClick={onUndo}
          disabled={!canUndo}
          aria-label="Undo"
          title="Undo (⌘Z)"
          className={cn(ghostBtn, "pointer-events-auto")}
          data-testid="board-undo"
        >
          <Undo2 className="h-3.5 w-3.5" />
        </button>
        <button
          type="button"
          onClick={onRedo}
          disabled={!canRedo}
          aria-label="Redo"
          title="Redo (⌘⇧Z)"
          className={cn(ghostBtn, "pointer-events-auto")}
          data-testid="board-redo"
        >
          <Redo2 className="h-3.5 w-3.5" />
        </button>
      </div>

      <div
        className="pointer-events-none absolute right-2 top-2 z-20 flex items-center gap-0.5"
        data-testid="board-canvas-controls-right"
      >
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              type="button"
              aria-label="Export"
              title="Export"
              className={cn(ghostBtn, "pointer-events-auto")}
              data-testid="board-export-menu"
            >
              <FileDown className="h-3.5 w-3.5" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="min-w-[180px]">
            <DropdownMenuItem onClick={onDownloadBoard}>Download PNG</DropdownMenuItem>
            {isAdmin ? (
              <DropdownMenuItem onClick={onAddBoardToNote}>Add to note…</DropdownMenuItem>
            ) : null}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </>
  );
}
